import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "youtube" }, [
      _createElementVNode("path", {
        id: "Icon",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M13.4695 2.67054C14.0722 2.85712 14.5459 3.40486 14.7073 4.10187C14.9988 5.36394 15 7.9987 15 7.9987C15 7.9987 15 10.6335 14.7073 11.8956C14.5459 12.5926 14.0722 13.1403 13.4695 13.3268C12.3782 13.6654 7.99998 13.6654 7.99998 13.6654C7.99998 13.6654 3.62183 13.6654 2.53045 13.3268C1.92773 13.1403 1.45407 12.5926 1.29272 11.8956C1 10.6335 1 7.9987 1 7.9987C1 7.9987 1 5.36394 1.29272 4.10187C1.45407 3.40486 1.92773 2.85712 2.53045 2.67054C3.62183 2.33203 7.99998 2.33203 7.99998 2.33203C7.99998 2.33203 12.3782 2.33203 13.4695 2.67054ZM10.3422 7.9989L6.5319 10.1986V5.79913L10.3422 7.9989Z",
        fill: "#8E8E93"
      })
    ], -1)
  ])))
}
export default { render: render }